import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './components/Pages/Dashboard';
import DrivingSchools from './components/Pages/drivingSchool/DrivingSchools';
import Installments from './components/Pages/installment/Installments';
import SideNav from './components/SideNav';
import Users from './components/Pages/User/Users';
import Assessments from './components/Pages/Assessments';
import BBJourney from './components/Pages/BBJourney';
import Scores from './components/Pages/scores/Scores';
import Rescheduling from './components/Pages/Rescheduling';
import Engagement from './components/Pages/engagement/Engagements';
import Purchase from './components/Pages/purchase/Purchase';
import Settings from './components/Pages/settings/Settings';
import Sidebar from './components/Sidebar/SideBar'
// import News from './components/Pages/news/News';
import Corporate from './components/Pages/Corporate';
import CorporateUser from './components/Pages/CorporateUser';
import CorporatePetroleum from './components/Pages/CorporatePetroleum';
import CorporatePetroleumUser from './components/Pages/CorporatePetroleumUser';
import RakshakLogin from './components/rakshaklogin/RakshakLogin';
import Footer from './components/Footer';
import './scss/style.css'
import firebase from './utils/Firebase';

import { RRServer } from './utils/lib';
import UserList from './components/Pages/User/UserList';
import Profile from './components/Pages/profile/Profile';
import ClassesList from './components/Pages/classes/ClassesList';
import InstallmentsList from './components/Pages/installment/InstallmentList';
import ScoresList from './components/Pages/scores/ScoresList';
import NewsClone from './components/Pages/news/News';
import EngagementClone from './components/Pages/engagement/Engagements';
// import StudentStats from './components/Pages/studentStats/StudentStats';
import SettingsClone from './components/Pages/settings/Settings';
import StudentStats from './components/Pages/studentStats/StudentStats';
import StudentStatsClone from './components/Pages/studentStats/StudentStats';
import StudentStatClone from './components/Pages/studentStats/StudentStatsList';
import Cluster from './components/Pages/cluster/Clusters';
import EngagementAdd from './components/Pages/engagement/EngagementAdd';
import SettingsAdd from './components/Pages/settings/SettingsAdd';
import Associations from './components/Pages/association/Associations';
import ClustersClone from './components/Pages/cluster/Clusters';
import PurchaseClone from './components/Pages/purchase/Purchase';
import DrivingSchoolAdd from './components/Pages/drivingSchool/DrivingSchoolAdd';
import AssociationAdd from './components/Pages/association/AssociationAdd';
import ClusterAdd from './components/Pages/cluster/ClusterAdd';
import UserListNew from './components/Pages/UserNew/UserListNew';
import Clusters from './components/Pages/cluster/Clusters';
import LiveClasses from './components/Pages/liveClasses/LiveClasses';
import News from './components/Pages/news/News';
import BulkRescheduling from './components/Pages/BulkRescheduling/BulkRescheduling';
import SalesAdd from './components/Pages/Sales/Sales';
import Enquires from './components/Pages/Enquires/Enquires';
import EnquiresList from './components/Pages/Enquires/EnquiresList';
import UpdateInstructor from './components/Pages/UpdateInstructor';
// import SalesAdd from './components/Pages/sales/salesAdd';



interface AppState {
  menuVisible: boolean,
  collapsed: boolean,
  isSignedIn: boolean,
  corporate: boolean,
  currentLoggedInSchool: any
}

class App extends Component {
  unregisterAuthObserver: any;
  constructor(props: any) {
    super(props);
    this.state = {
      menuVisible: false,
      collapsed: false,
      isSignedIn: false,
      corporate: false,
      currentLoggedInSchool: null
    }
  }


  componentDidMount() {
    const claimsString: any = localStorage.getItem('claims');
    const claims = JSON.parse(claimsString);
    let corporate = false;
    if (!!claims) {
      corporate = !!claims.corporate;
    }

    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
      (user: any) => {
        if (!!user) {
          const uid = user.uid;
          RRServer.list({ table: RRServer.Tables.DRIVING_SCHOOLS, forCurrentUser: false, where: [['firebaseUserUid', '==', uid]] })
            .then((r: any) => this.setState({ isSignedIn: true, currentLoggedInSchool: r?.data.data[0], corporate }))
            .catch((r: any) => console.log(r))
          this.setState({ displayName: user.displayName, corporate })
        } else {
          this.setState({ isSignedIn: false })
        }
      }
    );
  }

  componentWillUnmount() {
    this.unregisterAuthObserver();
  }



  logout() {
    firebase.auth().signOut().then(function () {
      window.location.href = '/dashboard';
    }, function () {
      alert('Error Signing Out')
    })
  }

  render() {

    const path = window.location.href
    const claimsString = localStorage.getItem('claims') || '{}';
    const claims = JSON.parse(claimsString);
    const isLoggedIn = localStorage.getItem('claims');
    const isSkl = claims.drivingSchoolId !== "*" && claims.drivingSchoolId !== "#" ? true : false;
    const isSuperAdmin = claims.drivingSchoolId === "*" ? true : false
    const isClusterAdmin = claims.drivingSchoolId === "#" && claims?.userType === "CLUSTER" ? true : false
    const isAssociationAdmin = claims.drivingSchoolId === "#" && claims?.userType === "ASSOCIATION" ? true : false
    const isSalesUser = claims.drivingSchoolId === "#" && claims?.userType === "SALES" ? true : false

    return (
      <>
        <div className='mainWrapper'>
          {!path.endsWith('/') && <Sidebar />}
          <div className='rightContainer small'>
            <BrowserRouter>
              <Routes>
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/dashboard' element={<Dashboard />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/enquires' element={<EnquiresList />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/enquires/add' element={<Enquires />} />}

                {/* {<Route path='/drivingschools' element={<DrivingSchools />} />} */}
                {isLoggedIn && (isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/drivingschools' element={<DrivingSchools />} />}
                {isLoggedIn && (isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/drivingschools/add' element={<DrivingSchoolAdd />} />}
                {isLoggedIn && (isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/drivingschools/edit/:schoolId' element={<DrivingSchoolAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/association' element={<Associations />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/association/add' element={<AssociationAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/association/edit/:id' element={<AssociationAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/cluster' element={<Clusters />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/cluster/add' element={<ClusterAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/sales' element={<SalesAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/cluster/edit/:id' element={<ClusterAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/updateInstructor' element={<UpdateInstructor />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/usersOld' element={<UserListNew />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/classes' element={<ClassesList />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/liveClasses' element={<LiveClasses />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isSalesUser) && <Route path='/installments' element={<InstallmentsList />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/scores' element={<ScoresList />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/studentStats' element={<StudentStats />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/bbjourney' element={<BBJourney />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/assessments' element={<Assessments />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/rescheduling' element={<Rescheduling />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isAssociationAdmin || isSalesUser) && <Route path='/bulRescheduling' element={<BulkRescheduling />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isSalesUser) && <Route path='/engagement' element={<EngagementAdd />} />}
                {isLoggedIn && (isSuperAdmin || isSkl || isSalesUser) && <Route path='/purchase' element={<Purchase />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isAssociationAdmin || isSalesUser) && <Route path='/news' element={<News />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/corporate' element={<Corporate />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/corporateUser' element={<CorporateUser />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/corporatePetroleum' element={<CorporatePetroleum />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/corporatePetroleumUser' element={<CorporatePetroleumUser />} />}
                {isLoggedIn && (isSuperAdmin || isSalesUser) && <Route path='/settings' element={<Settings />} />}
                {isLoggedIn && (isSkl || isSuperAdmin || isClusterAdmin || isSalesUser) && <Route path='/profile' element={<Profile />} />}
                <Route path='/' element={<RakshakLogin />} />
              </Routes>
            </BrowserRouter>
          </div>
        </div>
        {/* {!path.endsWith('/login') && path.endsWith('/') && <Footer />} */}
      </>
    );
  }
}

export default App;

